import { render, staticRenderFns } from "./updatePermissionAction.vue?vue&type=template&id=5577d044&"
import script from "./updatePermissionAction.vue?vue&type=script&lang=js&"
export * from "./updatePermissionAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports